module.exports = __webpack_public_path__ + "media/images/icons/hospital-white-879ddc586c43646642a7056f7f41358c.svg";